module.exports = __webpack_public_path__ + "img/grabx.762bde23.png";